import React, { useContext, useEffect, useState } from "react";
import "./header.scss";
import mainLogo from "../../images/mainLogo.png";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { DropDownIcon, ProfileIcon } from "../../icons/svg";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import axios from "axios";
import Config from "../../common/Config";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, setUser } = useContext(UserContext);
  const [fullName, setFullName] = useState("");

  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    let config = {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      },
    };
    const response = await axios.post(
      Config.baseSecurityUrl + "api/v1/Account/Logout",
      "",
      config
    );
    if (response.data !== null) {
      localStorage.clear();
      navigate(`${process.env.REACT_APP_ORDER_FORM}/login`);
      setAnchorEl(null);
      setUser("");
    }
  };

  const handleHome = async () => {
    navigate(`${process.env.REACT_APP_ORDER_FORM}/`);
  };

  useEffect(() => {
    const userName = JSON.parse(localStorage?.getItem("token")).userName;
    const email = localStorage?.getItem("username");

    const newWord = email
      ? email
      : userName;

    setFullName(newWord);
  }, []);

  return (
    <div className="headerWrapper">
      <div className="header">
        <div>
          <a href="#home" onClick={handleHome}><img src={mainLogo} alt="main logo" width={256}/></a>
        </div>
        <div className="userName">
          <div>
            <Button
              id="demo-customized-button"
              aria-controls={open ? "demo-customized-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleClick}
              endIcon={<DropDownIcon />}
            >
              <p className="fullName">{fullName}</p>
              {/* <p className="shortName">{initialName}</p> */}
              <div className="shortName">
                <ProfileIcon />
                {/* <FedExIcon /> */}
              </div>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              className="headerMenu"
            >
              <p className="shortName">
                <MenuItem onClick={handleClose}>{fullName}</MenuItem>
              </p>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
